import React, { FunctionComponent, ReactNode } from 'react';
import { MainLayout } from './main';

export const MainLayoutWithTheme: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => <MainLayout>{children}</MainLayout>;
